import React from 'react';
import { motion } from 'framer-motion';
import { WrenchIcon, UtensilsIcon, ZapIcon, BrainIcon, MoonIcon, CalendarIcon } from 'lucide-react';
const benefits = [{
  icon: WrenchIcon,
  title: 'Functional Core Repair',
  description: "In 14 days, using 5-minute breathing and activation exercises you can do while your baby plays on the floor, you will feel a change in your posture and core stability that no amount of crunches ever gave you. Because we're closing the gap first — healing the structure so everything else actually works."
}, {
  icon: UtensilsIcon,
  title: 'Pro-Hormonal Nutrition',
  description: 'No macros. No calorie counting. No starvation. The "Holy Plate" method keeps your insulin flat, teaches your body to use pregnancy fat as fuel, and keeps your energy consistent — no 4 PM crash, no brain fog, no choosing between eating and feeding your baby. You will stop being exhausted by your own body.'
}, {
  icon: ZapIcon,
  title: 'The 12-Minute Activation',
  description: 'No gym. No equipment. No hour-long commitment. The Metabolic Burst protocol — done barefoot in your pajamas — spikes your metabolism for the next 24 hours using compound movements that recruit every muscle group at once. 12 minutes. Real results. Zero excuses needed.'
}, {
  icon: BrainIcon,
  title: 'The Identity Ritual',
  description: 'Every morning, before the world demands anything from you, two minutes of visual anchoring and breathing trains your brain to remember: you still exist. This is the antidote to Mom Brain, to invisible-woman syndrome, to waking up and immediately becoming a function instead of a person. You will start your day as a woman first. A mother second. Both at full power.'
}, {
  icon: MoonIcon,
  title: 'Broken Sleep Optimization',
  description: "You will not sleep 8 hours. We know. So instead of pretending that's the goal, we optimize your micro-sleep quality using targeted supplementation (magnesium, glycine), blue light management, and sleep architecture science so that 4 hours of optimized sleep restores you closer to what 6 hours used to. This is where the fat loss actually happens. This is where you stop running on fumes."
}, {
  icon: CalendarIcon,
  title: 'The 30-Day Action Plan',
  description: 'No confusion. No guessing. Every day is mapped. Week 1: Core awakening and body awareness. The daily success metrics are simple, achievable, and build momentum from day one — even on the days when everything feels impossible. You will always know exactly what to do next.'
}];
export function BenefitsSection() {
  return <section className="bg-white px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-1">
      <div className="mx-auto max-w-6xl" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-3">
          <h2 className="mb-4 font-serif text-4xl font-bold text-[#2D2D2D] sm:text-5xl" data-id="element-4">
            This isn't a list of features.
          </h2>
          <p className="font-serif text-3xl italic text-[#D4603A]" data-id="element-5">
            This is a preview of your next 90 days.
          </p>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-6">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="group relative rounded-2xl bg-[#FBF7F0] p-8 shadow-sm transition-shadow hover:shadow-md" data-id="element-7">
                <div className="mb-6 inline-flex rounded-xl bg-white p-4 shadow-sm" data-id="element-8">
                  <Icon className="h-6 w-6 text-[#D4603A]" data-id="element-9" />
                </div>
                <h3 className="mb-4 font-serif text-2xl font-bold text-[#2D2D2D]" data-id="element-10">
                  {benefit.title}
                </h3>
                <p className="font-sans text-base leading-relaxed text-[#2D2D2D]/80" data-id="element-11">
                  {benefit.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}